import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'
import './layout.scss'
import './button.scss'

const Layout = ({ children, siteTitle, secondary, tertiary }) => {
	return (
		<StaticQuery
			query={graphql`
				query SiteTitleQuery {
					site {
						siteMetadata {
							title
							description
							keywords
						}
					},
					imageHero: file(relativePath: { eq: "quiz/hero.jpg" }) {
						childImageSharp {
							fixed(width: 552, height: 368) {
								src
							}
						}
					}
				}
			`}
			render={data => {
				const pageTitle = siteTitle !== undefined ? `${data.site.siteMetadata.title} - ${siteTitle}` : data.site.siteMetadata.title

				const secondaryVar = secondary !== undefined ? `|${secondary.name}|` : '';
				const tertiaryVar = tertiary !== undefined ? `${tertiary.name}` : ''

				const varTitle = siteTitle !== undefined ? `${data.site.siteMetadata.title}|${siteTitle}${secondaryVar}${tertiaryVar}` : data.site.siteMetadata.title
				return (
				<>
					<Helmet
						title={pageTitle}
						meta={[
							{
								name: 'description',
								content: data.site.siteMetadata.description,
							},
							{
								name: 'keywords',
								content: data.site.siteMetadata.keywords,
							},
							{
								property: 'og:title',
								content: pageTitle
							},
							{
								property: 'og:description',
								content: data.site.siteMetadata.description
							},
							{
								property: 'og:image',
								content: "https://www.mckinsey.com" + data.imageHero.childImageSharp.fixed.src
							}
						]}
					>
						<html lang="en" />
						<script data-react-helmet="true">
							{`
								var McKinsey = {"Title":"${varTitle}","ContentType":"Careers Quiz"};
								//console.log(data.imageHero);
							`}
						</script>
						<script src="//assets.adobedtm.com/b0dfb38aec8a/63974894e9a9/launch-a400cfbb2fd3.min.js"></script>
					</Helmet>
					{children}
				</>
			)}}
		/>
	)
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export const imageMobileFragment = graphql`
  fragment imageMobile on File {
    childImageSharp {
      fluid(maxWidth: 1536) {
        ...GatsbyImageSharpFluid_noBase64
      }
    }
  }
`

export const imageFragment = graphql`
  fragment image on File {
    childImageSharp {
      fluid(maxWidth: 2560) {
        ...GatsbyImageSharpFluid_noBase64
      }
    }
  }
`

export default Layout
